import gql from 'graphql-tag'

const serviceList = gql`query GetServiceList {
  service {
    displayText
    path
    blurb
    serviceTags
    serviceIcon {
      urls
    }
    serviceType {
      contentItems {
        displayText
      }
    }
    showOnHomePage
  }
}`

const serviceDetail = gql`query GetServiceDetail($path: String!) {
  service(where: { path: $path }) {
    displayText
    blurb
    serviceType {
      contentItems {
        displayText
      }
    }
    serviceTags
    imageTextOverlay
    relatedServices {
      contentItems {
        ... on Service {
          displayText
          path
        }
      }
    }
    bannerImage {
      paths
    }
    bannerContent {
      html
    }
    seoMeta {
      canonical
      pageTitle
      metaDescription
      metaKeywords
    }
    serviceStats {
      contentItems {
        ... on StatBlock {
          displayText
          statQuantity
        }
      }
    }
  }
}`

const serviceDetail2 = gql`query GetServiceDetail2($path: String!) {
  service(where: { path: $path }) {
    bag {
      contentItems {
        ... on ContentBlockFlowpart {
          displayText
          contentBlockSubtitle
          image {
            urls
          }
          imagePosition
          markdownBody {
            html
          }
          sectionStyle
        }
        ... on Accordion {
          displayText
          subtitle
          accordionContent {
            contentItems {
              ... on AccordionItem {
                displayText
                markdownBody {
                  html
                }
              }
            }
          }
        }
        ... on Buttons {
          buttonList {
            contentItems {
              displayText
              ... on LinkMenuItem {
                linkMenuItem {
                  url
                }
              }
            }
          }
        }
        ... on HeadlineCollection {
          displayText
          bag {
            contentItems {
              ... on HeadlineItem {
                markdownBody {
                  markdown
                }
              }
            }
          }
        }
        ... on IconTextBlockCollection {
          iconColour
          displayText
          subtitle
          layout
          iconTextBlocks {
            contentItems {
              ... on IconTextBlock {
                displayText
                googleIcon
                content
              }
            }
          }
        }
        ... on Text {
          displayText
          textAlign
          content {
            html
          }
        }
        ... on ImageCardCollection {
          displayText
          subtitle
          imageCards {
            contentItems {
              ... on ImageCard {
                displayText
                images {
                  urls
                }
              }
            }
          }
        }
      }
    }
  }
}`

export {
  serviceList,
  serviceDetail,
  serviceDetail2
}